<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
            primary--text
            text-subtitle-2
            text-sm-subtitle-1
            text-md-subtitle-1
            text-lg-subtitle-1
            text-xl-subtitle-1
          "
          >{{ translations.label_cultivation_area_name }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-text-field
          v-model="data.name"
          :error="data.error"
          :error-messages="data.message"
          outlined
          clearable
          dense
           :label="translations.label_name"
          class="
            text-subtitle-2
            text-sm-subtitle-1
            text-md-subtitle-1
            text-lg-subtitle-1
            text-xl-subtitle-1
          "
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="addArea"
          block
          class="
            mb-5
            text-subtitle-2
            text-sm-subtitle-1
            text-md-subtitle-1
            text-lg-subtitle-1
            text-xl-subtitle-1
          "
        >
          {{ translations.label_rename }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: Boolean,
    name: String,
  },
  data: () => ({
    data: { error: false, message: "", name: "" },
  }),
  created() {
    this.data.name = this.name;
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addArea() {
      if (this.data.name.length > 0) {
        this.$emit("getName", this.data.name);
        this.data = { error: false, message: "", name: "" };
        this.show = false;
      } else {
        this.data.error = true;
        this.data.message = this.translations.advice_error;
      }
    },
  },
};
</script>

<style scoped></style>
